import { useDocsRoute } from './docs-route-context';

const imageMap = import.meta.glob('../../content/docs/**/screenshots/*', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

interface Props {
  src?: string;
  alt?: string;
}

export function DocsImage({ src, alt }: Props) {
  const { role } = useDocsRoute();
  const altText = alt ?? '';

  if (!src) {
    return <DocsImagePlaceholder alt={altText} />;
  }

  const normalized = src.startsWith('./') ? src.slice(2) : src;
  const key = `../../content/docs/${role}/${normalized}`;
  const url = imageMap[key];

  if (!url) {
    return <DocsImagePlaceholder alt={altText} />;
  }

  return (
    <img
      src={url}
      alt={altText}
      loading="lazy"
      className="my-4 max-w-full rounded-lg border"
    />
  );
}

function DocsImagePlaceholder({ alt }: { alt: string }) {
  return (
    <figure
      role="img"
      aria-label={alt}
      className="my-4 flex min-h-24 items-center gap-3 rounded-lg border border-dashed border-muted-foreground/40 bg-muted/30 px-4 py-6 text-sm text-muted-foreground"
    >
      <span aria-hidden className="text-2xl">
        📸
      </span>
      <figcaption className="italic">{alt || 'Screenshot coming soon'}</figcaption>
    </figure>
  );
}
